export default {
    "en": {
        currency: {
            style: 'currency',
            currency: 'USD',
        },
    },
    "fr": {
        currency: {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'symbol',
        },
    }
}